// Transform calendar API response to component format
export const transformCalendarData = (calendar) => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  return calendar.map((day) => {
    // Parse date string as local date to avoid timezone issues
    const [year, month, dayNum] = day.date.split("-").map(Number);
    const dayDate = new Date(year, month - 1, dayNum);
    const isFuture = dayDate > currentDate;

    if (isFuture) {
      return {
        date: day.date,
        dayNumber: dayDate.getDate(),
        status: "upcoming",
      };
    }

    if (!day.is_working_day) {
      return {
        date: day.date,
        dayNumber: dayDate.getDate(),
        status: "rest",
      };
    }

    // Determine shift type
    let shift = "AM";
    const hasAM = day.total_am_shift_delivered_order > 0;
    const hasPM = day.total_pm_shift_delivered_order > 0;

    if (hasAM && hasPM) {
      shift = "AM/PM";
    } else if (hasPM) {
      shift = "PM";
    }

    return {
      date: day.date,
      dayNumber: dayDate.getDate(),
      status: "completed",
      shift,
      amOrders: day.total_am_shift_delivered_order,
      pmOrders: day.total_pm_shift_delivered_order,
      totalOrders: day.total_orders,
      deliveredOrders: day.delivered_orders,
      hoursWorked: day.working_hours,
    };
  });
};

// Transform day details API response to component format
export const transformDayDetails = (data) => {
  // Parse date string as local date to avoid timezone issues
  const [year, month, dayNum] = data.date.split("-").map(Number);
  const dayDate = new Date(year, month - 1, dayNum);

  // Determine shift type
  let shift = "AM";
  const hasAM = data.total_am_shift_delivered_orders > 0;
  const hasPM = data.total_pm_shift_delivered_orders > 0;

  if (hasAM && hasPM) {
    shift = "AM/PM";
  } else if (hasPM) {
    shift = "PM";
  }

  // Calculate start and end times based on shift
  const startTime = shift === "PM" ? "14:00" : "08:00";
  const endTime = shift === "AM" ? "13:00" : "18:00";

  // Transform stops to delivery_routes format
  const delivery_routes = data.stops.map((stop) => {
    const orders = stop.order_list.map((order) => ({
      order_number: order.order_number,
      customer_name: order.customer_name,
      customer_phone: order.customer_phone,
      customer_code: order.customer_code,
      order_state: order.order_state,
      order_tag: "", // Not provided in API
      order_date: order.order_date,
      order_loaded: order.order_loaded,
      order_delivery_start: order.order_delivery_start,
      delivery_time_hours : order.delivery_time_hours,



      order_delivered: order.order_delivered,
      delivery_receiver_name: order.delivery_receiver_name,
      delivery_receiver_phone: order.delivery_receiver_phone,
      is_return_job: order.is_return_job,
      return_job_color: order.return_job_color,
      is_partial_job: order.is_partial_job,
      partial_job_color: order.partial_job_color,
      order_reason: order.order_reason,
      line_items: order.items.map((item) => ({
        item_code: item.stock_code,
        item_description: item.stock_description,
        item_loaded_qty: item.picked_qty.toString(),
        item_order_qty: item.order_qty.toString(),
        delivery_order_line_remarks: item.delivery_order_line_remarks,
        order_line_color_satate: item.order_line_color_satate,
      })),
      signature_files: order.signature_files,
      other_files: order.other_files,
    }));

    return {
      stop_number: stop.stop_no,
      stop_name: stop.stop_name,
      stop_state: stop.stop_state,
      total_order: stop.total_orders,
      total_delivered_order: stop.delivered_orders,
      total_failed_order: stop.failed_orders,
      returns_orders: stop.returns_orders,
      partial_orders: stop.partial_orders,
      order_list: orders,
    };
  });

  return {
    date: data.date,
    dayNumber: dayDate.getDate(),
    status: "completed",
    shift,
    amOrders: data.total_am_shift_delivered_orders,
    pmOrders: data.total_pm_shift_delivered_orders,
    totalOrders: data.total_orders,
    deliveredOrders: data.delivered_orders,
    failedOrders: data.failed_orders,
    hoursWorked: data.working_hours,
    totalStops: data.total_stops,
    startTime,
    endTime,
    delivery_routes,
  };
};
